export default __webpack_public_path__ + "static/media/user.2a740094.svg";